module.exports = __webpack_public_path__ + "img/presupuestos.afd0ee29.png";